<template lang='pug'>
  .empty-search-results
    .main-container
      p.bold
        | {{__(`We're sorry, we couldn't find any results for your search. Try your search again using these tips:`, 'categories')}}
      ul.bullet-points
        li {{__('Check your spelling', 'categories')}}
        li {{__('Try more general or similar words', 'categories')}}
        li {{__('Limit your search to one or two words', 'categories')}}
      p.bold
        | {{ __('If you still can\'t find what you are looking for,') }} &nbsp;
        rogue-link(to="/contact-us") {{ __('contact us.') }}
    .index-container.main-container(v-if="hasIndex")
      h4 Results from The Index
      PostsGrid.index-grid(:query="{search: $route.query.q}", :limit="3" :show-filters="false" v-if="hasIndex" :allow-load-more="false")
      RogueButton(@click="$emit('tab', 'The Index')") View More
    FeaturedProducts.featured.main-container
    ProductCarousel.main-container.products(
      :widget="widget"
      :podId="PODS.ZERO_RESULTS"
      title="Recommended Products"
    )
</template>

<script setup lang="ts">
import { ref, onMounted, defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'
import { useRogue } from '@/js/services/Rogue'
import FeaturedProducts from '@/js/pages/home/FeaturedProducts.vue'
import { widgets }      from '@/js/services/rfk/types'
import { PODS }         from '@/js/services/cnstrc/constants'

const PostsGrid = defineAsyncComponent(() => import(/* webpackChunkName: "category-empty-results" */'@/js/pages/theindex/components/posts-grid.vue'))

const route = useRoute()
const rogue = useRogue()

const widget = ref(widgets.SEARCH_EMPTY)
const hasIndex = ref(false)

defineEmits(['tab'])

onMounted(async () => {
  if (route.query.q) {
    const loadPosts = await import(/* webpackChunkName: "category-empty-results" */'@/js/pages/theindex/helpers/search').then(dflt => dflt.loadPosts)
    const posts = await loadPosts(rogue, { search: route.query.q as string }, { perPage: 1 })
    if (posts.length) {
      hasIndex.value = true
    }
  }
})
</script>

<style lang='scss' scoped>
.main-container:not(.index-grid) {
  margin-bottom: $space-xxxl
}
.bullet-points{
  margin-bottom: $space-s;
  padding-left: $space-m;
}
</style>
